import Api from "@/services/service-v2";
import { PolicyPayload } from "@/views/setup/return-policy/types";

export const fetchOrderPolicies = () =>
    Api().$http.get("/orders/api/v3/policies");

export const upsertOrderPolicies = (payload: PolicyPayload) =>
    Api().$http.put("/orders/api/v3/policies", payload);

export const fetchMarketPoliciesList = () =>
    Api().$http.get("/catalog/api/catalog/read/catalog/market-list");
